import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const ITEMS = ['Evalúas al paciente siguiendo una ruta diagnóstica ordenada.', 'Detectas rápidamente la verdadera causa de la maloclusión.', 'Comprendes qué función está alterando el crecimiento.', 'Sabes exactamente cuándo indicar cada aparato funcional.', 'Explicas el tratamiento con seguridad y respondes cualquier pregunta de los padres con fundamentos clínicos.', 'Sales del consultorio con la tranquilidad de haber tomado una decisión basada en criterio, no en intuición.'];
export function Imagine() {
  return <section className="w-full bg-ofm-900 px-5 py-14 sm:px-6 sm:py-20" data-id="element-144" data-mp="3rdlu5e8l06lh">
      <div className="mx-auto w-full max-w-2xl" data-id="element-145" data-mp="3nbqvyily69bx">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-146" data-mp="3ndbndzcytc5k">
          Imagina que, desde tu próxima consulta…
        </h2>

        <ul className="mt-8 space-y-3.5" data-id="element-147" data-mp="1ll6w8q3aiivw">
          {ITEMS.map(item => <li key={item} className="flex gap-3 rounded-2xl bg-white/[0.06] p-4 ring-1 ring-white/10" data-id="element-148" data-mp="a0u198g3a7yt">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-149" data-mp="ey3r2p7e4ln6" />
              <span className="text-[14px] leading-snug text-ofm-100 sm:text-[15px]" data-id="element-150" data-mp="518sy7f14n9f">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="mt-8 text-center text-[15px] font-semibold leading-relaxed text-white/80 sm:text-lg" data-id="element-151" data-mp="xqoevs88g0k4">
          Eso es exactamente lo que fue diseñado para lograr el Sistema de Decisión
          Clínica OFM.
        </p>

        <CTAButton className="mt-8" variant="gold" label="🦷 QUIERO ESTO EN MI PRÓXIMA CONSULTA" data-id="element-152" data-mp="o038vjq8btr6" />
        <p className="mt-3 text-center text-[12px] font-medium text-ofm-200 sm:text-sm" data-id="element-153" data-mp="1bp5zhh2ucwxt">
          Acceso inmediato · Pago único de $12.99 USD
        </p>
      </div>
    </section>;
}